/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from '../shared/Globals';
import { qreq } from '../shared/qrequest';
import BaseCom from './BaseCom';
import FormInput from './FormInput';
import Icon from './Icon';
import L from './Lang';
import { withParamsAndNavigate } from './WithParamsAndNavigate';
import './Shop.css';
import { Link } from 'react-router-dom';

const CATEGORY_PRODUCTS_ROUTE = '/shop';

class ShopCategory extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            search: {},
            list: null,
            fullList: null,
            loading: true
        };
    }

    async componentDidMount() {
        const cart = await this.getCart();
        this.setState({ cart: cart });
        const categories = await this.getCategories();
        if (!categories || categories.length === 0) {
            setTimeout(() => {
                this.props.navigate('/shop');
            }, 100);
        }
        this.setState({ loading: false });
    }

    getCategories = async () => {
        try {
            let j = await qreq.getAsync('/api/category/list');

            const list = j.list;

            if (list) {
                this.setState({
                    list: list,
                    fullList: list
                });

                return list;
            }

            this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }

        return [];
    }

    getCategoryName = (i) => {
        return i.categoryName || i.name || i.title || '';
    }

    getCategoryCode = (i) => {
        return i.categoryCode || i.code || '';
    }

    getCategoryDescription = (i) => {
        return i.description || i.categoryDescription || '';
    }

    getCategoryImageIdent = (i) => {
        return i.imageIdent || i.iconIdent || i.logoIdent || '';
    }

    search = (v) => {
        const value = (v || '').toLowerCase();

        this.setState({
            list: this.state.fullList?.filter(x =>
                this.getCategoryName(x).toLowerCase().indexOf(value) >= 0
                || this.getCategoryCode(x).toLowerCase().indexOf(value) >= 0
                || this.getCategoryDescription(x).toLowerCase().indexOf(value) >= 0
            )
        });
    }

    clearSearch = () => {
        this.state.search.query = '';

        this.setState({
            search: { ...this.state.search },
            list: this.state.fullList
        });
    }

    openCategory = (i) => {
        const categoryId = encodeURIComponent(i.id);

        this.props.navigate(String(i.id));
    }

    renderCategory = (i, idx) => {
        const name = this.getCategoryName(i);
        const code = this.getCategoryCode(i);
        const description = this.getCategoryDescription(i);
        const imageIdent = this.getCategoryImageIdent(i);

        return (
            <div key={idx} className="shop-product-card shop-category-card" onClick={() => this.openCategory(i)}>
                <button
                    type="button"
                    className="shop-product-image"
                    title="View Category"
                >
                    {imageIdent ? (
                        <img src={Globals.getStorageURL(imageIdent)} alt={name} />
                    ) : (
                        <div className="shop-product-placeholder">
                            <Icon icon="faBoxOpen" />
                        </div>
                    )}
                </button>

                <div className="shop-product-content">
                    <div className="shop-product-meta">
                        {code ? (
                            <span><L>Category No</L>: {code}</span>
                        ) : (
                            <span><L>Category</L></span>
                        )}

                        {i.productCount !== undefined && i.productCount !== null ? (
                            <span>{i.productCount} <L>Products</L></span>
                        ) : null}
                    </div>

                    <h2>{name}</h2>

                    <p>{description}</p>

                    <button
                        type="button"
                        className="btn btn-link shop-details-link"
                    >
                        <L>View Products</L> <Icon icon="faArrowRight" />
                    </button>
                </div>

                <div className="shop-product-actions">
                    {i.isActive === false ? (
                        <div className="text-center mb-2">
                            <small className="text-muted"><L>Inactive Category</L></small>
                        </div>
                    ) : null}

                    <button
                        type="button"
                        className="btn btn-primary shop-action-btn"
                        title="View Products"
                    >
                        <Icon icon="faArrowRight" /> <L>Open</L>
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const count = this.state.list?.length ?? 0;

        return (
            <div className="shop-page">
                <div className="shop-hero">
                    <div>
                        <span className="shop-eyebrow"><L>Catalog</L></span>
                        <h1><L>Categories</L></h1>
                        <p><L>Browse product categories and open a category to view its products.</L></p>
                    </div>

                    <div role="button" className="shop-cart-pill" onClick={this.cartCheckout}>
                        <Icon icon="faCartShopping" />
                        <span>{this.state.cart?.totalQuantity ?? 0}</span>
                    </div>
                </div>

                <div className="shop-toolbar">
                    <div className="shop-search">
                        <Icon icon="faSearch" />
                        <FormInput
                            model={this.state.search}
                            name="query"
                            label="Search categories..."
                            labelAsPlaceholder
                            onChange={this.search}
                        />
                    </div>

                    {this.state.search?.query ? (
                        <button type="button" className="btn btn-light" onClick={this.clearSearch}>
                            <Icon icon="faCancel" /> <L>Clear</L>
                        </button>
                    ) : null}
                </div>

                {this.state.loading ? (
                    <div className="shop-loading">
                        <Icon icon="faRefresh" className="spinner" />
                        <span><L>Loading categories...</L></span>
                    </div>
                ) : count === 0 ? (
                    <div className="shop-empty">
                        <Icon icon="faBoxOpen" />
                        <h2><L>No Categories Found</L></h2>
                        <p><L>Try changing your search keywords.</L></p>
                    </div>
                ) : (
                    <div className="shop-product-list">
                        {this.state.list?.map((i, idx) => this.renderCategory(i, idx))}
                    </div>
                )}
            </div>
        );
    }
}

export default withParamsAndNavigate(ShopCategory);